// The brand accents Loft tints with, named once.
//
// Worth a module of its own because a wrong one is invisible rather than loud: a
// palette path is a plain string to MUI's system props, so an unresolvable token
// paints nothing and typecheck says nothing. Both happened. CAM admin's spine
// disappeared because it pointed at `custom.lavender.500`, and lavender is
// deleted from this package's palette in theme.tsx; a stage chip lost its tint
// because `custom.neutral.70` has no 70 step, the ramps being 50 to 900.
//
// So the valid choices live here as a closed set, and anything tinting off-list
// is a type error. Lavender is absent on purpose: retired from the Figma
// collection, and the types in mui-augmentations.d.ts drop it too.
export const ACCENT = {
  marine: 'custom.marineGreen.700',
  marineLight: 'custom.marineGreen.500',
  lime: 'custom.limeGreen.500',
  limeInk: 'custom.limeGreen.700',
  coral: 'custom.coral.600',
  sunflower: 'custom.sunflower.500',
  cherry: 'custom.cherry.500',
  warmOrange: 'custom.warmOrange.700',
  muted: 'custom.neutral.600',
} as const;

export type Accent = (typeof ACCENT)[keyof typeof ACCENT];

/**
 * Which side of the product a project touches, and the accent that says so.
 *
 * The accent used to be picked per project, which made it decoration: twelve
 * cards in twelve colours, none of them telling you anything you couldn't read
 * in the title. Deriving it from the surface means scanning the landing page
 * answers "what does this touch" before you have read a word.
 *
 * `other` is for the entries that are not product work at all — the component
 * playground, the sandbox — and is deliberately the muted grey, so they read as
 * outside the scheme rather than as a fifth kind of surface.
 */
export const SURFACE = {
  member: { label: 'Member app', accent: ACCENT.marine },
  cam: { label: 'CAM', accent: ACCENT.warmOrange },
  both: { label: 'Member and CAM', accent: ACCENT.lime },
  partner: { label: 'Partner portal', accent: ACCENT.cherry },
  other: { label: 'Not product work', accent: ACCENT.muted },
} as const;

export type Surface = keyof typeof SURFACE;

/** The scheme in reading order, for the key on the landing page. */
export const SURFACES = Object.keys(SURFACE) as Surface[];
